import 'select2/dist/js/select2.full.min';

const selects = () => {
    $(document).on("gform_post_render", function (e, form_id) {
        $('.gfield_select').each(function () {
            let $this = $(this);

            let isMultiple = $this.prop('multiple');

            let placeholder;
            const $gfield = $this.closest('.gfield');

            if ($gfield.hasClass('gfield--label-as-placeholder')) {
                // Use label text, stripping required asterisk
                const $label = $gfield.find('.gfield_label');
                placeholder = $label.clone().children('.gfield_required').remove().end().text().trim();
            } else if ($('option:first-child', $this).hasClass('gf_placeholder')) {
                placeholder = $('option:first-child', $this).text();
            } else {
                placeholder = 'Please select';
            }

            let options = {
                placeholder: placeholder,
                selectionCssClass: isMultiple ? 'custom-form-multi-select' : 'custom-form-select',
                dropdownCssClass: isMultiple ? 'custom-form-multi-dropdown' : 'custom-form-dropdown',
                width: '100%',
                multiple: isMultiple
            };

            if (isMultiple) {
                options.minimumResultsForSearch = Infinity;
            }

            $this.select2(options);

            // For multi-selects, manually add placeholder if no items selected

            if (isMultiple) {
                let $container = $this.next('.select2-container');
                let $rendered = $container.find('.select2-selection__rendered');

                function updatePlaceholder() {
                    let hasSelection = $this.val() && $this.val().length > 0;
                    $rendered.find('.select2-placeholder').remove();
                    if (!hasSelection) {
                        $rendered.prepend('<li class="select2-placeholder">' + placeholder + '</li>');
                    }
                }

                updatePlaceholder();
                $this.on('change', updatePlaceholder);
            }
        });
    });

    document.querySelectorAll('.gfield_select').forEach(select => {
        function updateColor() {
            if (select.value === '') {
                select.classList.add('placeholder-active');
            } else {
                select.classList.remove('placeholder-active');
            }
        }
        select.addEventListener('change', updateColor);
        updateColor(); 
    });
};

export default selects;